import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import TextArea from 'component/atom/forms/text-area/TextArea';
import { useFormikContext } from 'formik';
import React from 'react';

const options = [
  { value: '0', label: 'Idle for 5 minutes' },
  { value: '1', label: 'Add Keyword' },
];
const EndForm = ({}) => {
  const formik = useFormikContext();
  return (
    <form
      className={'formCont'}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <RadioGroup
        name="trigger"
        selectedValue={formik.values.trigger}
        onChange={formik.handleChange}
        options={options}
        error={formik.errors.trigger}
        touched={formik.touched.trigger}
      />
      {formik.values.trigger == '1' && (
        <TextArea
          label="keyword"
          placeholder="Enter keyword"
          name="keyword"
          value={formik.values.keyword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.keyword}
          touched={formik.touched.keyword}
        />
      )}
    </form>
  );
};

export default EndForm;
